{
  "locale": "Français",
  "sidebar": {
    "title": "Demande de partage de données",
    "issuanceTitle": "Demande d'ajout de données",
    "authenticationTitle": "Demande d'authentification",
    "description": "{clientName} demande des données personnelles vérifiées depuis votre application d'identité. Consultez les détails ci-dessous et approuvez ou refusez cette demande dans votre application d'identité.",
    "issuanceDescription": "{clientName} ajoute des données vérifiées à votre application d'identité. Consultez les détails ci-dessous et confirmez dans votre application d'identité si vous souhaitez les accepter.",
    "authenticationDescription": "{clientName} souhaite s'authentifier avec votre application d'identité.",
    "descriptionFallback": "Un service demande des données personnelles vérifiées depuis votre application d'identité. Consultez les détails ci-dessous et approuvez ou refusez cette demande dans votre application d'identité.",
    "issuanceDescriptionFallback": "Un service ajoute des données vérifiées à votre application d'identité. Consultez les détails ci-dessous et confirmez dans votre application d'identité si vous souhaitez les accepter.",
    "authenticationDescriptionFallback": "Un service souhaite s'authentifier avec votre application d'identité.",
    "stepsTitle": "Étapes à compléter",
    "stepShareData": "Partager les données avec {clientName}",
    "stepAuthenticate": "S'authentifier pour {clientName}",
    "stepReceiveData": "Recevoir les données de {clientName}",
    "stepGeneric": "Compléter les étapes requises",
    "defaultClientName": "le service",
    "requestedDataTitle": "Les données suivantes sont demandées",
    "issuedDataTitle": "Les données suivantes seront émises",
    "reviewNotice": "Vous examinerez et approuverez les données exactes dans votre application d'identité avant que quoi que ce soit ne soit partagé.",
    "issuanceReviewNotice": "Vous examinerez et approuverez les données exactes dans votre application d'identité avant que quoi que ce soit ne soit ajouté.",
    "indeterminateHint": "Les données demandées seront visibles après avoir sélectionné une application d'identité",
    "showAll": "Tout afficher",
    "purposeStatementTitle": "Pourquoi vos données sont nécessaires",
    "retentionPolicyTitle": "Comment vos données sont traitées"
  },
  "footer": {
    "powered": "Propulsé par",
    "privacyPolicy": "Politique de confidentialité"
  },
  "topBar": {
    "openMenu": "Ouvrir le menu",
    "closeMenu": "Fermer le menu",
    "language": "Langue"
  },
  "app": {
    "loadingTitle": "Chargement en cours"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Rechercher",
    "noResults": "Aucun résultat"
  },
  "init": {
    "title": "Traitement de la demande",
    "hint": "Préparation de votre session"
  },
  "pairing": {
    "title": "Préparation de l'étape suivante",
    "hint": "Préparation de votre session",
    "codeLabel": "Vérifiez le code suivant dans votre application d'identité",
    "confirm": "Confirmer l'appairage"
  },
  "waitingForPresentation": {
    "title": "Continuez dans votre application d'identité",
    "hint": "Veuillez vérifier votre application d'identité pour examiner et approuver la demande"
  },
  "agentStart": {
    "title": "Continuer dans {appName}",
    "subtitle": "Pour partager vos données en toute sécurité, scannez ce code QR avec {appName} pour examiner et approuver la demande.",
    "issuanceSubtitle": "Pour recevoir les données en toute sécurité, scannez ce code QR avec {appName} pour examiner et approuver la demande.",
    "step1": "Ouvrir {appName}",
    "step2": "Cliquer sur l'icône du scanner",
    "step3": "Scanner ce code QR",
    "changeApp": "Changer d'application d'identité",
    "installInstructions": "Instructions d'installation",
    "cancel": "Annuler",
    "needHelp": "Besoin d'aide ?",
    "redirectSubtitle": "Cliquez sur le bouton ci-dessous pour ouvrir {appName} et approuver la demande.",
    "issuanceRedirectSubtitle": "Cliquez sur le bouton ci-dessous pour ouvrir {appName} et approuver la demande.",
    "redirectButton": "Continuer",
    "mobileSubtitle": "Pour partager vos données en toute sécurité, continuez dans {appName} pour examiner et approuver la demande.",
    "issuanceMobileSubtitle": "Pour recevoir les données en toute sécurité, continuez dans {appName} pour examiner et approuver la demande.",
    "openApp": "Ouvrir {appName}",
    "showQr": "Afficher le code QR"
  },
  "done": {
    "disclosure": {
      "title": "Les données ont été partagées avec succès",
      "subtitle": "La page se fermera automatiquement dans quelques secondes.",
      "subtitleCloseTab": "Données partagées avec succès. Vous pouvez fermer cette page."
    },
    "issuance": {
      "title": "Données reçues avec succès",
      "subtitle": "La page se fermera automatiquement dans quelques secondes.",
      "subtitleCloseTab": "Données reçues avec succès. Vous pouvez fermer cette page."
    },
    "redirecting": "Redirection...",
    "completeRedirect": "Terminer et rediriger",
    "redirectFailed": "La redirection automatique n'a pas fonctionné. Appuyez ci-dessous pour continuer."
  },
  "abort": {
    "cancelled": {
      "title": "Processus arrêté",
      "subtitle": "Vous avez choisi d'arrêter le processus. Vous pouvez recommencer à tout moment."
    },
    "serverError": {
      "title": "Une erreur s'est produite",
      "subtitle": "Nous n'avons pas pu terminer le processus en raison d'un problème technique."
    },
    "expired": {
      "title": "Session expirée",
      "subtitle": "Cette session a pris fin après une période d'inactivité. Pour continuer, fermez cette page et redémarrez le processus."
    },
    "connectionLost": {
      "title": "Connexion perdue",
      "subtitle": "Votre connexion Internet a été interrompue. Veuillez vérifier votre connexion et réessayer."
    },
    "temporarilyUnavailable": {
      "title": "Service temporairement indisponible",
      "subtitle": "Le service est actuellement en maintenance. Veuillez réessayer plus tard."
    },
    "appError": {
      "title": "Application d'identité indisponible",
      "subtitle": "Nous n'avons pas pu nous connecter à l'application d'identité sélectionnée. L'application est peut-être temporairement indisponible. Vous pouvez essayer une autre application d'identité ou réessayer plus tard."
    },
    "selectDifferentApp": "Sélectionner une autre application d'identité",
    "confirmTitle": "Arrêter le processus ?",
    "confirmMessage": "Êtes-vous sûr de vouloir arrêter ? Vous pouvez recommencer à tout moment si vous souhaitez continuer plus tard.",
    "confirmStop": "Arrêter le processus",
    "goBack": "Retour",
    "leave": "Quitter",
    "restart": "Redémarrer",
    "retry": "Réessayer",
    "contactOrganisation": {
      "subtitle": "Nous n'avons pas pu démarrer le processus. Veuillez contacter l'organisation pour obtenir de l'aide."
    }
  },
  "appPicker": {
    "title": "Applications d'identité prises en charge",
    "subtitle": "Les applications d'identité suivantes peuvent être utilisées pour examiner et approuver la demande",
    "searchPlaceholder": "Rechercher...",
    "sectionLastUsed": "Dernière utilisation",
    "sectionRecommended": "Recommandé",
    "sectionAZ": "A-Z",
    "noResults": "Aucune application ne correspond à votre recherche",
    "filterTitle": "Filtrer par pays",
    "filterClear": "Tout effacer",
    "filterDone": "Terminé"
  },
  "faq": {
    "helpQuestion": "Question",
    "moreHelp": "Plus d'aide",
    "close": "Fermer",
    "whatAreWallets": {
      "title": "Qu'est-ce que les applications d'identité ?",
      "body": "Avec une application d'identité, vous êtes responsable de vos propres données — vous seul décidez quelles données vous partagez, avec qui et quand. Vos données sont récupérées auprès d'un émetteur fiable et vérifié, puis placées dans l'application avec une signature numérique garantissant leur exactitude.\n\nLorsque vous partagez vos données avec un tiers, la signature numérique est incluse afin que la partie prenante puisse en vérifier l'authenticité. Vos données sont généralement stockées uniquement sur votre propre téléphone et peuvent facilement être récupérées si nécessaire.\n\nSoyez toujours conscient que c'est votre responsabilité de choisir avec soin avec qui vous partagez vos données."
    },
    "whyNotSupported": {
      "title": "Pourquoi mon application d'identité n'est-elle pas supportée ?",
      "body": "Il peut arriver que votre application d'identité ne soit pas disponible car la partie destinataire ou notre plateforme ne la supporte pas actuellement. Nous travaillons constamment à élargir notre gamme d'applications supportées.\n\nSi votre application n'est pas répertoriée, vous pouvez toujours installer et utiliser une des autres applications d'identité supportées."
    },
    "howDataProtected": {
      "title": "Comment mes données sont-elles protégées ?",
      "body": "Les applications d'identité garantissent que vous avez toujours le contrôle sur qui vous partagez vos données et quand. Ces applications vous fournissent généralement un aperçu des données partagées, avec qui et quand.\n\nVer.iD envoie vos données directement à la partie prenante et vérifie uniquement qu'elles ont été correctement livrées.\n\nSoyez toujours conscient que c'est votre responsabilité de choisir avec soin avec qui vous partagez vos données.",
      "link": "En savoir plus sur la sécurité et la confidentialité"
    },
    "howObtainData": {
      "title": "Comment puis-je ajouter des données dans mon application ?",
      "body": "Chaque application d'identité a sa propre manière de collecter des données. La plupart des applications ont un bouton qui vous permet d'ajouter des données. Dans certains cas, des coûts peuvent s'appliquer.\n\nSuivez les instructions de l'application pour collecter vos données en toute sécurité. Vous pouvez être redirigé vers des sites web gouvernementaux ou être tenu de scanner des documents comme des passeports ou des permis de conduire.\n\nSi vous ne voyez pas de moyen direct d'ajouter les données correctes, consultez la documentation de l'application ou contactez le fournisseur. Vous pouvez aussi essayer une autre application d'identité."
    },
    "whyRedirection": {
      "title": "Pourquoi suis-je redirigé ?",
      "body": "Certaines applications d'identité nécessitent une redirection vers leur propre site web afin que vos données soient partagées conformément à leurs normes, dans un environnement que vous connaissez.\n\nAprès un partage réussi, vous serez automatiquement redirigé vers Ver.iD, où vos données attendront votre confirmation avant d'être envoyées à la partie prenante. Un reçu numérique se trouve généralement dans votre application d'identité.\n\nSi le processus échoue ou est annulé, vous serez également redirigé et pourrez réessayer."
    }
  },
  "mobileFlowStart": {
    "startVerification": "Continuer"
  },
  "requestedDataModal": {
    "title": "Données demandées",
    "subtitle": "Vous examinerez et approuverez cette demande dans votre application d'identité.",
    "attribute": "Attribut",
    "description": "Description",
    "issuedBy": "Données émises par",
    "close": "Fermer"
  },
  "demo": {
    "title": "Environnement de démonstration",
    "description": "Vous utilisez une démonstration interactive de Ver.iD. Cet environnement est destiné uniquement à des fins de démonstration."
  },
  "installInstructions": {
    "title": "Installer {appName}",
    "subtitle": "Rendez-vous sur l'App Store ou le Play Store de votre téléphone pour installer l'application d'identité {appName}. Scannez le code pour ouvrir directement la page du store et installer l'application.",
    "close": "Fermer",
    "unavailableTitle": "Instructions non disponibles",
    "unavailableBody": "Désolé, nous n'avons pas d'instructions d'installation disponibles pour cette application pour le moment. Essayez de rechercher manuellement l'application dans le store pour continuer."
  },
  "embedded": {
    "loading": "Chargement des applications d’identité",
    "moreApps": "{count} autres applications",
    "moreAppsOne": "1 autre application",
    "useAnotherApp": "Utiliser une autre application",
    "cancel": "Annuler",
    "back": "Retour",
    "tryAgain": "Réessayer",
    "qr": {
      "caption": "Scannez avec {bold} pour partager vos données.",
      "captionIssuance": "Scannez avec {bold} pour ajouter vos données.",
      "label": "Code QR à scanner avec {app}",
      "noApp": "Pas d’application {app} ?",
      "whatShared": "Qu’est-ce qui est partagé ?",
      "whatAdded": "Qu’est-ce qui est ajouté ?",
      "expired": "Ce QR code a expiré.",
      "refresh": "Actualiser le QR"
    },
    "waiting": {
      "title": "Continuez dans {app}",
      "sub": "Approuvez la demande sur votre téléphone.",
      "subIssuance": "Acceptez les données sur votre téléphone.",
      "help": "Vous ne voyez pas la demande ?"
    },
    "done": {
      "title": "Partagé avec {app}",
      "sub": "Vous pouvez poursuivre votre demande.",
      "titleIssuance": "Ajouté à {app}",
      "subIssuance": "Vos données sont maintenant dans l’application."
    },
    "error": {
      "title": "Le partage n’a pas abouti",
      "sub": "Rien n’a été partagé.",
      "titleIssuance": "Vos données n’ont pas été ajoutées",
      "subIssuance": "Rien n’a été ajouté à {app}.",
      "help": "Pourquoi cela n’a-t-il pas abouti ?"
    },
    "unsupported": {
      "title": "{app} ne peut pas encore être utilisée ici",
      "sub": "Utilisez une autre application pour continuer."
    },
    "install": {
      "caption": "Installez d’abord {bold} : scannez avec l’appareil photo de votre téléphone.",
      "label": "Code QR pour télécharger {app} depuis votre magasin d’applications",
      "installed": "Je l’ai installée"
    },
    "missing": {
      "title": "Pas encore d’étapes d’installation",
      "sub": "Installez {app} comme l’indique son fournisseur, puis revenez."
    },
    "notListed": {
      "title": "Vous ne voyez pas votre application ?",
      "sub": "{org} n’accepte que ces applications. Choisissez-en une pour voir comment l’installer.",
      "subIssuance": "{org} ne peut ajouter des données qu’à ces applications. Choisissez-en une pour voir comment l’installer.",
      "back": "Retour aux applications"
    },
    "request": {
      "title": "Vous ne voyez pas la demande ?",
      "sub": "Gardez {app} ouverte, cela peut prendre quelques secondes. Toujours rien ? Scannez à nouveau le QR code.",
      "keepWaiting": "Continuer d’attendre",
      "scanAgain": "Scanner à nouveau"
    },
    "why": {
      "title": "Pourquoi cela n’a-t-il pas abouti ?",
      "sub": "Cela a été annulé dans {app} ou a pris trop de temps. Rien n’a été partagé.",
      "subIssuance": "Cela a été annulé dans {app} ou a pris trop de temps. Rien n’a été ajouté."
    },
    "details": {
      "label": "Ce qui est partagé",
      "caption": "Demandé par {bold}. Vous l’approuvez d’abord dans votre application.",
      "back": "Retour au code QR",
      "labelIssuance": "Ce qui est ajouté",
      "captionIssuance": "Émis par {bold}. Vous l’acceptez d’abord dans votre application.",
      "privacy": "Politique de confidentialité",
      "security": "Comment mes données sont-elles protégées ?"
    },
    "timeout": {
      "title": "Cette demande a expiré",
      "sub": "Les demandes restent ouvertes quelques minutes. Réessayez pour en obtenir une nouvelle."
    },
    "launch": {
      "title": "Partager avec {app}",
      "sub": "Touchez Ouvrir {app} pour voir et approuver la demande.",
      "titleIssuance": "Ajouter à {app}",
      "subIssuance": "Touchez Ouvrir {app} pour accepter les données.",
      "open": "Ouvrir {app}"
    },
    "opening": {
      "sub": "Approuvez la demande dans l’application.",
      "subIssuance": "Acceptez les données dans l’application.",
      "help": "{app} ne s’est pas ouverte ?"
    },
    "notOpened": {
      "title": "{app} ne s’est pas ouverte ?",
      "sub": "{app} n’est peut-être pas installée sur ce téléphone. Installez-la pour continuer.",
      "install": "Installer {app}"
    },
    "phoneInstall": {
      "title": "{app} n’est pas sur ce téléphone ?",
      "sub": "Téléchargez-la depuis votre magasin d’applications ou scannez avec un autre appareil.",
      "get": "Télécharger {app}",
      "scanOther": "Scanner avec un autre appareil"
    },
    "phoneQr": {
      "openHere": "Ouvrir {app} sur ce téléphone"
    },
    "drawer": {
      "close": "Fermer",
      "label": "Partagez vos données avec une application d’identité",
      "labelIssuance": "Ajoutez vos données à une application d’identité"
    }
  }
}
